import { SystemField } from "./system-field";

export class TransferProduct extends SystemField {
     
     ref_code?:string;
     external_ref_code?:string;
     transfer_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     transfer_type?:string;
     from_warehouse_id?:string;
     to_warehouse_id?:string;
     langs?: any;
}
export class TransferProdTranslate extends SystemField{
    
    lang_code?:string;
    transfer_product_id?:string;
    description?:string;
}
